import {ConfigProvider, Table} from "antd";
import React, {useEffect, useState} from "react";
import {CaseListingTableHeaders} from "../Constants";
import CaseListingFilters from "./CaseListingFilters";
import CaseListingHeader from "./CaseListingHeader";
import "../CaseListingStyles.css";
import {deleteWorkforceCase, getDataForWorkforceListing} from "../../../Services/workforce";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import {useDispatch} from "react-redux";
import {TablePageSizeOptions, WorkforceTablePageSize} from "../../../constant";
import {SET_CREATE_WORKFORCE_CASE_DETAILS,} from "../../../store/features/workforceSlice";
import NotifyActionsOnRecordModal from "../../../components/Modals/NotifyActionsOnRecordModal";

const CaseListingPage = () => {
    const dispatch = useDispatch();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: WorkforceTablePageSize,
            total: WorkforceTablePageSize + 2,
            showSizeChanger: true,
            pageSizeOptions: TablePageSizeOptions
        },
    });
    const [caseListingData, setCaseListingData] = useState([]);
    const [tableFilters, setTableFilters] = useState({});
    const [showNotifyActionsOnRecordModal,
        setShowNotifyActionsOnRecordModal] = useState(false);
    const [deletedRecord, setDeletedRecord] = useState();

    useEffect(() => {
        retrieveCaseListingDetails();
    }, []);

    const retrieveCaseListingDetails = (data) => {
        dispatch(SET_IS_API_CALLED("Retrieving Case Listing Data"));
        getDataForWorkforceListing({
            ...tableFilters,
            pageSize: data?.pageSize ?? tableParams?.pagination.pageSize,
            pageIndex: data?.current ?? tableParams?.pagination.current,
        })
            .then(response => {
                setCaseListingData(response?.data?.items.map(item => {
                    return {...item, key: item?.id}
                }));
                setTableParams(
                    {
                        pagination: {
                            current: response?.data?.pageIndex,
                            pageSize: data?.pageSize ?? WorkforceTablePageSize,
                            total: response?.data?.totalItems,
                            showSizeChanger: true,
                            pageSizeOptions: TablePageSizeOptions
                        }
                    });

                // clear the redux store to prevent spillover data
                dispatch(SET_CREATE_WORKFORCE_CASE_DETAILS({}));
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            })
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // rowSelection object indicates the need for row selection
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const deleteCase = (record) => {
        deleteWorkforceCase([record?.id]).then(() => {
        }).finally(() => {
            retrieveCaseListingDetails();
            dispatch(SET_IS_API_CALLED_FINISHED());
        })

    }

    return (
        <>
            <NotifyActionsOnRecordModal
                showNotifyActionsOnRecordModal={showNotifyActionsOnRecordModal}
                setShowNotifyActionsOnRecordModal={setShowNotifyActionsOnRecordModal}
                modalText={"Are you sure that you want to delete the case?"}
                modalTitle={"Deleting a case"}
                handleAction={() => {
                    // this forms a closure
                    deleteCase(deletedRecord)
                }}
            />

            <div className="p-4">
                <CaseListingHeader tableFilters={tableFilters}/>
                <CaseListingFilters caseListingData={caseListingData}
                                    setCaseListingData={setCaseListingData} tableParams={tableParams}
                                    setTableParams={setTableParams}
                                    setTableFilters={setTableFilters}
                />
                <ConfigProvider
                    theme={{
                        components: {
                            Table: {
                                headerBg: "#F5F5F5",
                                headerColor: "#2F5E8A",
                                headerSortActiveBg: "#F5F5F5",
                                headerSortHoverBg: "#F5F5F5",
                                fixedHeaderSortActiveBg: "#F5F5F5",
                            },
                        },
                    }}
                >
                    <Table
                        className="table-striped-rows"
                        dataSource={caseListingData}
                        rowSelection={rowSelection}
                        columns={CaseListingTableHeaders(setShowNotifyActionsOnRecordModal, setDeletedRecord)}
                        pagination={tableParams?.pagination}
                        onChange={retrieveCaseListingDetails}
                    ></Table>
                </ConfigProvider>
            </div>
        </>
    );
};

export default CaseListingPage;
